import React from 'react'
import {Box, SxProps, Theme, Typography} from '@mui/material'
import {useTheme} from '@mui/material/styles'
import {CARD_BORDER_RADIUS} from 'src/theme-new/tokens'

interface StatCardProps {
  value: React.ReactNode
  label: string
  sx?: SxProps<Theme>
}

// Generic replacement for legacy src/components/elements/BoxAderenza/BoxAderenza.tsx —
// a colored tile with a big value and a label underneath, e.g. an adherence
// percentage. Uses the PSP's brand color via theme.palette instead of the legacy
// component's hardcoded theme.palette.primary[500]/'#eff6e4'.
export default function StatCard({value, label, sx}: StatCardProps): JSX.Element {
  const theme = useTheme()

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        borderRadius: CARD_BORDER_RADIUS,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
        py: 2,
        ...sx,
      }}
    >
      <Typography sx={{fontSize: 36, fontWeight: 400, lineHeight: 1.2, color: 'inherit'}}>
        {value}
      </Typography>
      <Typography sx={{fontSize: 16, fontWeight: 400, mt: 0.5, color: 'inherit'}}>
        {label}
      </Typography>
    </Box>
  )
}
